import Page from "webPage/Page";
import Track from "util/Track";

Page.register('page-template-our-history', () => {
    let $track = $(".js-track-wrap");

    if ($track.length > 0) {
        new Track($track, {
            classes: {
                block: "slider",
            },
        });
    }
});
